// import Vue from 'vue'
// let vue = new Vue()
// let baseUrl = vue.$cdn

export default{
  main: {
    btnType: {
      buy: {
        name: '升级套餐',
        xufei: '立即续费'
      }
    },
    sn: 'S/N：',
    used: '已使用：',
    space: '容量套餐：',
    expire: '到期时间：'

  },
  information: {
    nameArr: {
      information: '账号信息',
      scene: '我的场景',
      order: '我的订单',
      device: '我的相机',
      consumption: '消费记录',
      change: '修改密码',
      logout: '退出登录'
    },
    settings: [
      {
        name: 'info',
        items: [{
          name: '账号信息',
          to: {name: 'information'}
        }, {
          name: '我的场景',
          to: {name: 'scene'}
        }, {
          name: '我的相机',
          to: {name: 'device'}
        }, {
          name: '我的订单',
          to: {name: 'order'}
        }, {
          name: '消费记录',
          to: {name: 'consumption'}
        }]
      },
      {
        name: 'security',
        items: [{
          name: '修改密码',
          to: {name: 'change'}
        }, {
          name: '退出登录',
          to: 'logout'
        }]
      }
    ],
    deviceSettings: [
      {
        name: 'security',
        items: [{
          name: '我的场景',
          to: {name: 'scene'}
        }, {
          name: '退出登录',
          to: 'logout'
        }]
      }
    ]
  },
  account: {
    info: '账号信息',
    address: '我的收货地址',
    invoice: '我的发票抬头',
    normal: '增值税普票（电子发票）',
    zengzhi: '增值税专用发票',
    edit: '编辑',
    show: '收起',
    avatar: '头像',
    nickname: '昵称',
    account: '账号',
    email: '邮箱',
    placeholder: {
      nickname: '输入昵称',
      phone: '电话',
      name: '姓名',
      email: '邮箱',
      address: '详细地址',
      title: '请输入发票抬头',
      code: '请输入18位税务登记号',
      raddress: '注册地址',
      rphone: '注册电话',
      bank: '开户银行',
      accout: '银行账户'
    },
    save: '保存',
    select: '选择图片',
    sinfo: [
      '请选择一张新照片进行上传',
      '支持图片格式为：JPG/PNG',
      '推荐分辨率为：512*512px，大小不大于1MB'
    ],
    isReceive: '获取四维看看优惠信息和最新动态'
  },
  myScenes: {
    edit: '编辑',
    delete: '删除',
    shooting: '拍摄时间：',
    id: 'S/N：',
    noScenes: '暂无任何场景，赶紧去拍摄吧。',
    placeholder: {
      searchID: '搜索场景'
    },
    delwarn: '确定要删除当前场景吗？',
    share: {
      calcule: '计算中',
      share: '分享',
      website: '场景网址',
      shareto: '分享到',
      qianru: '嵌入式制作',
      size: '尺寸',
      width: '宽：',
      height: '高：',
      defaultSize: '(默认窗口尺寸：853 X 480px)',
      copy: '复制',
      sub: '将嵌入代码粘贴至HTML编辑器中，就像嵌入网络视频一样简单。您也可以将以上代码发送给您的网络管理员，并要求他们将其放置在网页指定位置上。',
      sub2: '*该功能有效期与您的容量使用情况有关，有可能因未续费容量而导致失效。',
      copysuccess: '复制成功',
      copyfail: '复制失败',
      delsuccess: '删除成功',
      delfail: '删除失败，'
    },
    limit: {
      insufficient: '云端容量不足<br/>场景已封存',
      recharge: '恢复>>',
      expand: '扩容'
    }
  },
  myOrders: {
    numbers: '订单号：',
    product: '商品',
    quantity: '数量',
    subtotal: '价格',
    total: '总价：￥',
    cancal: '取消订单',
    pay: '立即付款',
    norecord: '暂无任何订单，赶紧去购买吧。',
    invoice: '发票信息',
    wlNum: '物流单号：',
    unshipped: '等待商家发货',
    finish: '已完成',
    partShipped: '部分发货',
    received: '已收货',
    hasCancal: '已取消',
    edit: '修改（发货后7天内可修改）',
    dontneed: '发票类型：不需要发票',
    type1: '不需要发票',
    type2: '增值税普票（电子发票）',
    type3: '增值税专用发票',
    title: '发票抬头',
    code: '18位税务登记号',
    email: '电子邮箱',
    organizedAddress: '注册地址',
    registerPhone: '注册电话',
    bankName: '开户银行',
    bankAccount: '银行账户',
    save: '保存',
    cancal1: '取消'

  },
  myDevices: {
    add: '添加新设备',
    tabList: [
      {
        name: '四维看看Pro',
        id: 4
      }, {
        name: '四维看看Lite',
        id: 0
      }
    ],
    placeholder: {
      searchID: '搜索设备S/N'
    },
    storage: '云容量：',
    renew: '续费',
    upgrade: '升级',
    capacity: '扩容',
    unbind: '解绑',
    recharge: '充值',
    expire: '到期：',
    expand: '套餐：',
    jijiang: '即将到期',
    rongliang: '容量已满',
    norecord: '暂无任何记录'
  },
  Spending: {
    tabList: [
      {
        name: '扩容记录'
      }, {
        name: '充值记录'
      }, {
        name: '增值发票'
      }
    ],
    norecord: '暂无任何记录',
    placeholder: {
      searchID: '搜索设备S/N'
    }
  },
  modify: {
    code: '获取验证码',
    codep: '验证码',
    newpass: '新密码（最少8位以上数字和字母）',
    comfirm: '再次输入新密码（最少8位以上数字和字母）',
    submit: '提交'
  },
  cart: {
    cart: '您的购物车',
    nothing: '您的购物车空空如也<br/>赶紧行动吧',
    shop: '立即购买'
  }
}



// WEBPACK FOOTER //
// ./src/store/language/cn/manage.js